import { featuredVideos, latestUpdates } from './home';

export interface ArticleData {
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  rating: number;
  image: string;
  duration: string;
  description: string;
  content: string;
  tags: string[];
  director: string;
  cast: string;
  year: string;
  region: string;
  updateTime: string;
  viewCount: number;
}

export const articles: Record<string, ArticleData> = {
  'qingyu-nian-2': {
    slug: 'qingyu-nian-2',
    title: '庆余年 第二季',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 9.4,
    image:
      'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20with%20ancient%20palace%20setting%2C%20warm%20golden%20lighting%2C%20traditional%20costume%20drama%2C%20rich%20red%20and%20gold%20decor%2C%20cinematic%20composition%2C%20majestic%20visual%20style%20with%20soft%20atmospheric%20shadows&width=1200&height=675&seq=article-qyn-2&orientation=landscape',
    duration: '36集',
    description:
      '范闲归来，京都风云再起！看范闲如何在权力漩涡中运筹帷幄，揭开重重谜团，重塑庆国格局。第二季延续第一季的高水准制作，剧情更加扣人心弦。',
    content: `<h2>剧情简介</h2>
<p>《庆余年》第二季延续了第一季的故事线，范闲在经历了种种考验后，逐渐揭开了自己身世的秘密。面对朝堂上的明争暗斗，他以过人的智慧和胆识，在危机四伏的京都中稳步前行。</p>
<p>本季剧情更加紧凑，多条故事线交织并行。范闲与林婉儿的感情也经历了新的考验，而皇帝、太子、二皇子等角色之间的关系也愈发复杂。</p>
<p>编剧巧妙地将权谋、悬疑、爱情等元素融合在一起，让观众在每一集中都能感受到紧张刺激的氛围。第二季的制作水准全面升级，无论是场景搭建还是服装道具都更加精良。</p>
<h2>角色介绍</h2>
<p>范闲依然是全剧的核心人物，他在本季中展现出更加成熟的一面。面对越来越多的挑战，他不再单纯依靠小聪明，而是学会了从大局出发思考问题。</p>
<p>其他主要角色如范建、陈萍萍、庆帝等也都有重要戏份，每个角色的命运走向都牵动着观众的心弦。</p>
<h2>观看体验</h2>
<p>本剧采用4K超高清画质，配备专业级的音效处理，为观众带来沉浸式的观看体验。建议使用大屏幕设备观看，以充分感受精良的制作水准。</p>`,
    tags: ['热播', '古装', '权谋'],
    director: '孙皓',
    cast: '张若昀、李沁、陈道明、吴刚',
    year: '2026',
    region: '中国大陆',
    updateTime: '2026-08-06',
    viewCount: 2850000,
  },
  'liulangdiqiu-3': {
    slug: 'liulangdiqiu-3',
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'dianying',
    rating: 8.9,
    image:
      'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20adventure%20with%20Earth%20and%20cosmic%20background%2C%20dramatic%20orange%20and%20blue%20color%20contrast%2C%20epic%20cinematic%20scale%2C%20planet%20Earth%20illuminated%20by%20thrusters%2C%20grand%20space%20opera%20visual&width=1200&height=675&seq=article-ldq-3&orientation=landscape',
    duration: '148分钟',
    description:
      '人类命运何去何从？太阳系的终结倒计时开始，人类文明将面临前所未有的终极挑战。流浪地球系列最新力作，视觉特效全面升级。',
    content: `<h2>故事背景</h2>
<p>《流浪地球3》设定在前作故事的数年后，人类在漫长的星际旅途中遇到了前所未有的危机。太阳氦闪的威胁即将成为现实，人类必须做出最后的抉择。</p>
<p>本片讲述了一支由刘培强带领的精英小队，为了拯救人类的未来而展开的惊心动魄的冒险故事。他们穿越危险的星际空间，面对未知的挑战，用自己的勇气和智慧守护着人类文明的最后希望。</p>
<h2>视觉特效</h2>
<p>作为中国科幻电影的标杆之作，《流浪地球3》的视觉特效达到了新的高度。超过2000个特效镜头由中国本土团队制作完成，每一个画面都经过精心打磨，呈现出令人震撼的视觉效果。</p>
<p>从地球发动机的壮观景象到外太空的美丽星云，影片以令人惊叹的画面展现了科幻世界的无限可能。</p>
<h2>主题深度</h2>
<p>影片不仅是一部视觉盛宴，更深入探讨了人类在面对末日危机时的选择与担当。「带着家园去流浪」这一独特的中国式科幻理念，在本片中得到了更加深刻的诠释。</p>`,
    tags: ['热播', '科幻', '大片'],
    director: '郭帆',
    cast: '吴京、刘德华、李雪健',
    year: '2026',
    region: '中国大陆',
    updateTime: '2026-08-05',
    viewCount: 4200000,
  },
  'fanhua': {
    slug: 'fanhua',
    title: '繁花',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 9.3,
    image:
      'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20night%20scene%20with%20neon%20lights%2C%20vintage%20luxury%20cars%2C%20nostalgic%20Chinese%20metropolitan%20atmosphere%2C%20warm%20golden%20evening%20glow%2C%20elegant%20retro%20urban%20aesthetic&width=800&height=500&seq=article-fh&orientation=landscape',
    duration: '30集全',
    description:
      '改编自金宇澄同名小说，讲述了上世纪九十年代上海滩的商业传奇与人间百态。王家卫导演首部电视剧作品，画面美学极致的年代传奇。',
    content: `<h2>故事背景</h2>
<p>《繁花》以九十年代的上海为背景，讲述了阿宝从一个普通青年成长为商界传奇的故事。在那个充满机遇与挑战的年代，阿宝凭借敏锐的商业嗅觉和过人的智慧，在上海滩书写了属于自己的传奇。</p>
<p>剧中不仅有扣人心弦的商业博弈，更有细腻动人的情感描写。阿宝与玲子、李李之间的感情纠葛，成为全剧最动人的线索之一。</p>
<h2>艺术风格</h2>
<p>作为王家卫导演的电视剧处女作，《繁花》延续了他标志性的视觉美学。每一帧画面都经过精心构图，光影的运用达到了极致，将九十年代上海的独特韵味展现得淋漓尽致。</p>
<p>配乐方面同样出色，选用了大量九十年代的金曲，唤起观众对那个年代的美好回忆。</p>
<h2>社会价值</h2>
<p>《繁花》不仅是一部优秀的电视剧作品，更是一幅记录中国改革开放后社会变迁的时代画卷。它以细腻的笔触描绘了普通人在大时代背景下的奋斗与成长。</p>`,
    tags: ['年代剧', '商战', '爱情'],
    director: '王家卫',
    cast: '胡歌、马伊琍、唐嫣、辛芷蕾',
    year: '2024',
    region: '中国大陆',
    updateTime: '2026-08-06',
    viewCount: 5600000,
  },
  'manjianghong': {
    slug: 'manjianghong',
    title: '满江红',
    category: '电影',
    categorySlug: 'dianying',
    rating: 8.5,
    image:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20night%20with%20red%20lanterns%20hanging%2C%20mysterious%20atmospheric%20shadows%2C%20traditional%20Chinese%20architecture%2C%20historical%20suspense%20drama%20setting%2C%20dark%20moody%20cinematography&width=800&height=500&seq=article-mjh&orientation=landscape',
    duration: '159分钟',
    description:
      '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇的凶案牵出惊天阴谋，小兵张大与亲兵营副统领孙均被迫卷入其中。',
    content: `<h2>剧情概要</h2>
<p>南宋绍兴年间，一代忠良岳飞含冤而死。四年后，奸臣秦桧率领禁军与金国在边境会谈。就在会谈前夜，金国使者离奇死在了秦桧的驻地，随身携带的密信也不翼而飞。</p>
<p>小兵张大和亲兵营副统领孙均被卷入这场惊天阴谋之中。在有限的一个时辰内，他们必须找到凶手和密信的下落，否则将面临灭顶之灾。</p>
<h2>角色演绎</h2>
<p>影片集结了众多实力派演员，每个角色都被演绎得入木三分。张译饰演的何立阴险狡诈，沈腾饰演的张大在平凡中见真章，易烊千玺饰演的孙均则展现出了少年将军的英气与纠结。</p>
<p>特别是雷佳音饰演的秦桧，将一个奸臣的阴险、恐惧与挣扎表现得淋漓尽致，堪称全片的演技担当。</p>
<h2>艺术特色</h2>
<p>影片采用了独特的戏剧化叙事手法，将传统戏曲元素与现代电影语言完美融合。配乐方面大量运用了豫剧和摇滚音乐的结合，营造出独特的视听体验。</p>`,
    tags: ['悬疑', '古装', '喜剧'],
    director: '张艺谋',
    cast: '沈腾、易烊千玺、张译、雷佳音',
    year: '2023',
    region: '中国大陆',
    updateTime: '2026-08-05',
    viewCount: 8900000,
  },
  'quan-zhi-gao-shou-3': {
    slug: 'quan-zhi-gao-shou-3',
    title: '全职高手 第三季',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 9.1,
    image:
      'https://readdy.ai/api/search-image?query=Anime%20style%20competitive%20gaming%20arena%20with%20holographic%20effects%2C%20futuristic%20esports%20environment%2C%20vibrant%20neon%20cyan%20lighting%2C%20dynamic%20action%20composition%2C%20energetic%20digital%20competition%20atmosphere&width=800&height=500&seq=article-qzgs&orientation=landscape',
    duration: '12集全',
    description:
      '电竞大神叶修重返荣耀之巅的传奇故事。第三季画面制作全面升级，战斗场景更加炫酷，剧情节奏紧凑刺激。',
    content: `<h2>故事简介</h2>
<p>《全职高手》第三季延续了叶修重返荣耀巅峰的传奇故事。在组建了新战队兴欣之后，叶修带领着一群性格各异的队友，向着职业联赛的最高荣誉发起了冲击。</p>
<p>本季中，叶修将面对更加强大的对手，同时也要处理队内成员之间的磨合问题。每一场比赛都充满了悬念和惊喜，让观众为之热血沸腾。</p>
<h2>制作升级</h2>
<p>第三季在画面制作上有了显著提升，战斗场景的动作设计更加流畅，特效也更加炫目。角色的表情和动作细节经过精心打磨，让每一个角色都更加生动立体。</p>
<h2>电竞文化</h2>
<p>作为一部以电子竞技为主题的动漫作品，《全职高手》不仅展现了精彩的对战过程，更深入探讨了电竞选手的职业生涯、团队合作以及追逐梦想的精神。</p>`,
    tags: ['热血', '竞技', '游戏'],
    director: '史涓生',
    cast: '阿杰、季冠霖、杨天翔',
    year: '2026',
    region: '中国大陆',
    updateTime: '2026-08-04',
    viewCount: 1650000,
  },
  'dixia-cheng-yu-yongshi': {
    slug: 'dixia-cheng-yu-yongshi',
    title: '地下城与勇士：起源',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 8.8,
    image:
      'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20dungeon%20scene%20with%20warrior%20characters%2C%20epic%20action%20pose%2C%20stone%20walls%20with%20glowing%20runes%2C%20dramatic%20magical%20lighting%2C%20game%20adaptation%20anime%20visual%20style&width=800&height=500&seq=article-dnf&orientation=landscape',
    duration: '24集全',
    description:
      '经典游戏改编动画力作，讲述了勇士们在阿拉德大陆上的冒险故事。精良的画面制作，还原经典角色的魅力。',
    content: `<h2>故事背景</h2>
<p>《地下城与勇士：起源》改编自经典网络游戏《地下城与勇士》，讲述了在阿拉德大陆上，一群勇士为了守护家园而展开的冒险故事。</p>
<p>动画完美还原了游戏中各个经典角色的形象和性格特点，无论是鬼剑士的坚毅、格斗家的热血，还是魔法师的智慧，都在动画中得到了生动的展现。</p>
<h2>制作特色</h2>
<p>动画采用了最新的制作技术，战斗画面流畅华丽，角色的技能特效还原度极高。每场战斗都经过精心设计，力求给观众带来与游戏一样的热血体验。</p>
<p>音乐方面邀请了知名作曲家操刀，为每个重要场景配上了恰到好处的背景音乐。</p>`,
    tags: ['游戏改编', '冒险', '热血'],
    director: '李豪凌',
    cast: '吴磊、赵路、沈磊',
    year: '2026',
    region: '中国大陆',
    updateTime: '2026-08-03',
    viewCount: 980000,
  },
  'minglong-shaonian': {
    slug: 'minglong-shaonian',
    title: '鸣龙少年',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 8.6,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20Chinese%20high%20school%20classroom%20with%20bright%20sunlight%2C%20warm%20inspiring%20campus%20atmosphere%2C%20youth%20drama%20setting%2C%20desks%20with%20books%2C%20hopeful%20coming-of-age%20visual%20style&width=800&height=500&seq=article-mlsn&orientation=landscape',
    duration: '30集全',
    description:
      '聚焦当代高中生的青春成长故事，展现他们在学业、友情和梦想中的奋斗与选择。真实感人的校园剧，引发广泛共鸣。',
    content: `<h2>故事简介</h2>
<p>《鸣龙少年》讲述了在一所重点高中里，一群性格各异的高中生在通往高考的道路上，经历的欢笑与泪水、迷茫与成长。</p>
<p>剧中通过多个角色的视角，展现了当代青少年面对学业压力、家庭期待和自我追求时的真实状态。每个角色都有自己的故事，每个故事都触动人心。</p>
<h2>教育思考</h2>
<p>本剧不仅是一部青春校园剧，更深入探讨了教育的本质。它通过生动的故事情节，引发观众对应试教育、素质教育以及青少年心理健康等问题的思考。</p>
<h2>演员表现</h2>
<p>年轻演员们的表现可圈可点，他们将角色的青涩、热血、迷茫和成长演绎得真实自然，让观众仿佛看到曾经的自己。</p>`,
    tags: ['青春', '校园', '励志'],
    director: '丁黑',
    cast: '张若昀、黄尧、王锵',
    year: '2024',
    region: '中国大陆',
    updateTime: '2026-08-02',
    viewCount: 2100000,
  },
};

export function getArticleBySlug(slug: string): ArticleData | undefined {
  return articles[slug];
}

export function getRelatedArticles(currentSlug: string, categorySlug: string, limit = 4): ArticleData[] {
  return Object.values(articles)
    .filter((a) => a.slug !== currentSlug && a.categorySlug === categorySlug)
    .slice(0, limit);
}

export function getArticlesByCategory(categorySlug: string): ArticleData[] {
  return Object.values(articles).filter((a) => a.categorySlug === categorySlug);
}